// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__0B9VW","select":"ColumnChartDisplay_select__AFjoV"};